import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=d839631e&scoped=true&"
import script from "./MobileMenuButton.vue?vue&type=script&lang=js&"
export * from "./MobileMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuButton.vue?vue&type=style&index=0&id=d839631e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d839631e",
  null
  
)

/* custom blocks */
import block0 from "./MobileMenuButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports